import {Mapper} from '@s-ui/domain'

export class SeoAdsListSemanticPrivateSellerMetaConfigMapper extends Mapper {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Object} deps.config
   * @param {Object} deps.log
   * */
  constructor({config}) {
    super()
    this._config = config
    this._seoConfig = this._config.get('seo')
  }

  _getAdsListSemanticConfigKey = ({make, model, bodyType, province}) => {
    const hasMake = Boolean(make)
    const hasModel = Boolean(model)
    const hasBodyType = Boolean(bodyType)
    const hasProvince = Boolean(province)

    // These are the six combinations of SEO Metadata typologies
    // for privateSeller ads-list pages [/particulares/]
    const isDefault = !hasMake && !hasBodyType && !hasProvince
    const isMake = hasMake && !hasBodyType
    const isBodyType = !hasMake && hasBodyType && !hasProvince
    const isMakeBodyType = hasMake && hasBodyType && !hasModel
    const isProvince = !hasMake && !hasBodyType && hasProvince
    const isBodyTypeProvince = !hasMake && hasBodyType && hasProvince

    switch (true) {
      case isDefault:
        return 'default'
      case isMake:
        return 'make'
      case isBodyType:
        return 'bodyType'
      case isMakeBodyType:
        return 'make'
      case isProvince:
        return 'province'
      case isBodyTypeProvince:
        return 'bopyTypeProvince'
      default:
        return 'default'
    }
  }

  map = ({adsListSemanticConfig, params: {make, model, bodyType, province}}) => {
    const adsListSemanticConfigKey = this._getAdsListSemanticConfigKey({
      make,
      model,
      bodyType,
      province
    })
    return adsListSemanticConfig[adsListSemanticConfigKey] || adsListSemanticConfig.default
  }
}
